import { css } from '@emotion/react';
import { breakpoints } from '../../styles';
import { p2r, PrimaryProps } from '../../styles/fonts';

const styles = (color) => css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 47%;
  font-weight: 500;
  color: ${color};

  @media (max-width: ${breakpoints.tablet}px) {
    width: 100%;
  }

  .percent-container {
    display: flex;
    align-items: baseline;
    padding-bottom: ${p2r(11)};
  }

  .percent {
    font-size: ${p2r(100)};
  }

  .unit {
    font-size: ${p2r(64)};
  }

  .percent-text {
    font-size: ${p2r(24)};
  }
  ${PrimaryProps}
`;

export default styles;
